module.exports = __webpack_public_path__ + "media/customizations/westphalia/logo-dc12eebf2e7499d77a11e1611e3178d2.png";